import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import comicsSlice from '../redux/comicsSlice';
import charactersSlice from '../redux/charactersSlice';

export const store = configureStore({
  reducer: {
    comics: comicsSlice,
    characters: charactersSlice
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
